<script>
	// From Lucide
	import { ChevronsUpDown } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ChevronsUpDown class={iconClass} />
